import type { Psychologist } from "../core/types";
import { i18next } from "../components/i18n";

export function formatPsychologistModel(
  d?: Partial<Psychologist>,
): Psychologist {
  if (!d) {
    return {
      psychologistId: null,
      gender: "",
      headline: i18next.t("PSYCHOLOGIST_TITLE_DESCRIPTION"),
      comments: [],
      summary: "",
      thumbnail: null,
      bigImage: null,
      languages: [],
      specialities: [],
      slots: [],
      phone: "",
      hsa: "",
      descriptions: [],
      headlineEnum: undefined,
      absenceStatus: null,
      employmentType: null,
    };
  }
  return {
    psychologistId: d.psychologistId || null,
    gender: d.gender || "",
    headline: d.headline || i18next.t("PSYCHOLOGIST_TITLE_DESCRIPTION"),
    comments: d.comments || [],
    summary: d.summary || "",
    thumbnail: d.thumbnail || null,
    bigImage: d.bigImage || null,
    languages: Array.isArray(d.languages) ? d.languages : [],
    specialities: d.specialities || [],
    slots: d.slots || [],
    phone: d.phone || "",
    hsa: d.hsa || "",
    descriptions: d.descriptions || [],
    headlineEnum: d.headlineEnum || undefined,
    absenceStatus: d.absenceStatus || null,
    employmentType: d.employmentType || null,
  };
}
